import {ControlBarAction} from 'common/query-builder/query-entry-section/constants';

/**
 * We don't want to enable some controls behaviors saved metrics. This is the
 * list of actions that are not allowed.
 * */
export const nestedSavedMetricBannedActions: ControlBarAction[] = [
  ControlBarAction.Delete,
  ControlBarAction.Duplicate,
  ControlBarAction.Rename,
  ControlBarAction.SaveMetric,
];
